export const SET_PRODUCTS_LIST_DATA = (state, data) => {
    state.list.prodcutCategoeis = data.prodcutCategoeis;
    state.list.data = data.data.data;
    state.list.links = data.data.links;
    state.list.meta = {
      current_page: data.data.current_page,
      from: data.data.from,
      to:  data.data.to,
      total: data.data.total,
      perPage: data.data.per_page
  }
}